import React from "react";

import styles from "../../JobShiftPreStart/JobShiftPreStartView.module.css";

export default function EmergencyPlanResponseProcedureSection({ section, sectionNumber = 3 }) {
  const data = section && section.data ? section.data : {};
  const phases = Array.isArray(data.phases) ? data.phases : [];
  const displayName = section && section.display_name
    ? section.display_name
    : "Emergency Response Procedure";
  const validPhases = phases.map((phase, phaseIndex) => ({
    phase,
    phaseIndex,
    steps: Array.isArray(phase && phase.steps)
      ? phase.steps.filter((step) => String(step || "").trim() !== "")
      : []
  }));
  const hasContent = validPhases.some((entry) => entry.steps.length > 0);

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview}`} style={{ background: "#e9c84a", color: "#1f1031" }}>
          {sectionNumber}
        </span>
        {displayName}
      </div>
      <div className={styles.PreviewSectionBody}>
        {data.summary && String(data.summary).trim() ? (
          <div className={styles.PreviewPadding}>{data.summary}</div>
        ) : null}
        <table className={`${styles.PreviewTable} ${styles.EmergencyPlanScenarioTable}`}>
          <colgroup>
            <col style={{ width: "40px" }} />
            <col />
          </colgroup>
          <tbody>
            {hasContent ? validPhases.map(({ phase, phaseIndex, steps }) => (
              <React.Fragment key={phase.id || phaseIndex}>
                <tr className={styles.EmergencyResponsePhaseRow}>
                  <td colSpan={2}>
                    <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: "22px", height: "22px", borderRadius: "50%", background: "#2d1a47", color: "#fff", fontSize: "11px", fontWeight: 600 }}>
                      {phaseIndex + 1}
                    </span>
                    <span style={{ marginLeft: "8px", fontWeight: 700 }}>{phase && phase.name ? phase.name : ""}</span>
                  </td>
                </tr>
                {steps.map((step, stepIndex) => (
                  <tr key={`${phaseIndex}-${stepIndex}`}>
                    <td style={{ fontWeight: 700 }}><span style={{ paddingLeft: "5px" }}>{phaseIndex + 1}.{stepIndex + 1}</span></td>
                    <td>{step}</td>
                  </tr>
                ))}
              </React.Fragment>
            )) : (
              <tr>
                <td colSpan={2}>No emergency response phases or steps available.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
